import { BankPaymentsRepository } from "../../domain/repositories/BankPaymentsRepository";
import { BankPaymentSummaryEntity } from "../../domain/entities/BankPaymentSummaryEntity";
import { RecoApiDataSource } from "../datasources/RecoApiDataSource";

export class BankPaymentsRepositoryImpl implements BankPaymentsRepository {
  private dataSource: RecoApiDataSource;

  constructor() {
    this.dataSource = new RecoApiDataSource();
  }

  async getPendingPaymentsSummary(): Promise<BankPaymentSummaryEntity> {
    const response = await this.dataSource.fetchBankPaymentsSummary();

    return {
      totalPendingCustomerPayments:
        response.data.total_pending_customer_payments || 0,
      totalPendingCustomerAmount:
        response.data.total_pending_customer_amount || 0,
      totalPendingVendorPayments:
        response.data.total_pending_vendor_payments || 0,
      totalPendingVendorAmount:
        response.data.total_pending_vendor_amount || 0,
      currencyCode: response.data.currency_code || "INR",
      accountsCount: response.data.accounts_count || 0,
    };
  }
}

